import React from "react";
import { PillAnchor } from "../../../../../CommonComponents/EditLinkToPill/styles";
import pencil from "../../../../../assets/icons/edit.svg";
import close from "../../../../../assets/icons/close-circle.svg";
import history from "../../../../../history/history";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { editStepperIndex, updateStepperAllToFinish } from "../../../../../actions/globalActions";
import { Triangle, InfoView, CloseTag, Info1, InfoCheck, EllipsisText, InfoName, FlexEnd } from "./styles";
import { initiateTracking, recordError } from "../../../../../utils/commonUtil";

export function InfoRectangleNPA(props) {

  const checkForStepperStatus = (e) => {
    let element = document.querySelector('.stepperCheck');
    let stepperElement = document.querySelector('.ant-steps.ant-steps-horizontal.ant-steps-label-horizontal');
    if(element && !element.contains(e.target) && !stepperElement.contains(e.target)){
      props.closed(e);
    }
  }

  React.useEffect(() => {
    window.addEventListener('click',(e) => {
      checkForStepperStatus(e);
    },true)
    return () => {
      window.removeEventListener('click',(e) => {
        checkForStepperStatus(e);
      },true)
    }
  }, []);

  const checkForUndefined = (data,type) => {
    if(data !== undefined){
      if(data.constructor === Array){
        return data;
      }else{
        return data[type];
      }
    }else{
      return null;
    }
  }

  const getActivePageName = () => {
    if(props.activePageStepNumber === 2){
      return 'Step 2 Legacy options';
    }
    return 'Step 3 Review and Submit';
  }

  const routeTo = () => {
    try {
      props.editStepperIndex({
        status: true,
        index: props.data.key
      });
  
      let tempStepper = [
        {
          key: 1,
          description: "Provide account information",
          status: "process",
          route: "/open-an-additional-account/account-information/",
          pageName: "step1Setup"
        },
        {
          key: 2,
          description: "Legacy options",
          status: "wait",
          route: "/open-an-additional-account/legacy-options/",
          pageName: "step2Legacy"
        },
        {
          key: 3,
          description: "Review and Submit",
          status: "wait",
          route: "/open-an-additional-account/review/",
          pageName: "step3Review"
        }
      ];
  
      if(props.data.route === "/open-an-additional-account/account-information/"){
      initiateTracking('edit','Open Additional Account',getActivePageName(),'Edit - Step 1 Provide Account Information - Stepper');
      let {addresses,email,phone,info} =  props.secondaryAdvisor;
      let tempFormat = {
          info: info,
          reset: false,
          addresses: [{
            addressId: 0,
            addresstype: undefined,
            city: null,
            country: null,
            line1: null,
            line2: null,
            line3: null,
            state: undefined,
            zipcode: null,
            primary: true
          }],
          email: [{
            addressId: 0,
            emailId: null,
            emailtype: undefined,
            primary: true
          }],
          phone: [{
            addressId: 0,
            phonenumber: null,
            phonetype: undefined,
            primary: true
          }]
        }
        let advisorCount = getNoOfAdvisors();
        if(advisorCount != 1){
          tempFormat = {
            addresses: checkForUndefined(addresses,'addresses'),
            email:checkForUndefined(email,'email'),
            info: info,
            phone: checkForUndefined(phone,'phone'),
            reset: false,
          }
        }
  
        props.updateStepperAllToFinish(tempStepper);
  
  
        history.push({
          pathname: props.data.route,
          state: { primaryAdvisorForEdit: props.primaryAdvisor, secondaryAdvisorForEdit: tempFormat, tempCheckBoxStatus: props.tempCheckBoxStatus }
        })
      }else{
        initiateTracking('edit','Open Additional Account',getActivePageName(),'Edit - Step 2 Legacy options - Stepper');
        tempStepper[0].status = "finish";
        tempStepper[1].status = "process";
        tempStepper[2].status = "wait";
        props.updateStepperAllToFinish(tempStepper);
        history.push(props.data.route);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getNoOfAdvisors = () => {
    let advisorCount = 0;
    if(props.activePageStepNumber === 3){
      if(props.tempData.advisors[1] && props.tempData.advisors[1].firstname){
        advisorCount = 2;
        if(props.tempData.advisors[1].firstname == ""){
          advisorCount = 1;
        }
        if(props.tempData.advisors[1].firstname == null){
          advisorCount = 1;
        }
      }else{
        advisorCount = 1;
      }
    }else{
      if(props.secondaryAdvisor.info.firstname == ""){
        advisorCount = 1;
      }else{
        advisorCount = 2;
        if(props.secondaryAdvisor.info.firstname == null){
          advisorCount = 1;
        }
      }
    }
    return advisorCount;
  }

  const getDeliveryMethod = (deliveryMethod) => {
    switch(deliveryMethod){
      case "E-Delivery": return "Electronic delivery";
      case "Paper": return "Paper delivery";
      default: return "U.S. mail with email notification";
    }
  }

  const renderInfoDynamicStep = () => {
    let allData = {};
    let bestow = 0;
    let endow = 0;
    let advisorCount = getNoOfAdvisors();
    
    if (props.activePageStepNumber == 2) {
      allData = props.primaryAdvisor;
    }
    if (props.activePageStepNumber > 2) {
      allData = props.tempData;
      allData.legacyOptions.forEach(val => {
        if (val.optionId == 1 || val.optionId == 2) {
          bestow += +val.percentage;
        } else {
          endow += +val.percentage;
        }
      });
    }
    return (
      <>
        <div>
          <div>
          </div>
          {props.data.key == 1 ? (
            props.activePageStepNumber == 2 ? (
              <>
              <InfoCheck>
                <InfoName>
                  {allData.info.name}
                </InfoName>
               <InfoView flex={true}>
               <div>
               <div>Number of advisors: {advisorCount}{" "} </div>
                <div>
                 {getDeliveryMethod(allData.info.deliveryMethod)}
                </div>
               </div>
                <FlexEnd>
                  <PillAnchor disabled={false} stepper={true} onClick={routeTo}>
                    <span>Edit</span>
                    <img src={pencil} className="ml-05" alt="Edit" />
                  </PillAnchor>
                </FlexEnd>
               </InfoView>
              </InfoCheck>
              </>
            ) : (
              <InfoCheck>
                <InfoName>
                  {allData.advisors[0].firstname}{" "}
                  {allData.advisors[0].middlename}{" "}
                  {allData.advisors[0].lastname}{" "}
                </InfoName>
               <InfoView flex={true}>
               <div>
               <div>Number of advisors: {advisorCount}{" "} </div>
                <div>
                  {allData.advisors[0].deliveryMethod == "E-Delivery"
                    ? "Electronic delivery"
                    : allData.advisors[0].deliveryMethod == "PD"
                    ? "Paper delivery"
                    : "U.S. mail with email notification"}
                </div>
               </div>
                <FlexEnd>
                  <PillAnchor disabled={false} stepper={true} onClick={routeTo}>
                    <span>Edit</span>
                    <img src={pencil} className="ml-05" alt="Edit" />
                  </PillAnchor>
                </FlexEnd>
               </InfoView>
              </InfoCheck>
            )
          ) : (
            <>
              <EllipsisText>The {allData.fundName ? allData.fundName : ""} Fund</EllipsisText>
              <div>Bestow to others: {bestow ? bestow : "0"}%</div>
              <div>Endow to charity: {endow ? endow : "0"}%</div>
            </>
          )}
        </div>
        <CloseTag onClick={props.closed}><img src={close} alt="Close" /></CloseTag>
        {props.data.key !== 1 && (
          <PillAnchor disabled={false} stepper={true} data-test="edit-btn-click" onClick={routeTo}>
            <span>Edit</span>
            <img src={pencil} className="ml-05" alt="Edit" />
          </PillAnchor>
        )}
      </>
    );
  };
  
  const getOffsetWidth = () => {
    if(window.screen.width > 576){
      return 341;
    }
    return document.querySelector('.ant-steps.ant-steps-horizontal.ant-steps-label-horizontal').offsetWidth;
  }

  return (
    <Info1 activeKey={props.data.key} size = {getOffsetWidth()} className="stepperCheck"> 
      <InfoView flex={props.data.key !== 1}>{renderInfoDynamicStep()}</InfoView>
      <Triangle activeKey={props.data.key}/>
    </Info1>
  );
}

const mapStateToProps = state => ({
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON", "tempJSON"]),
  primaryAdvisor: state.getIn(["npaFormReducer", "primaryAdvisor"]),
  secondaryAdvisor: state.getIn(["npaFormReducer", "secondaryAdvisor"]),
  tempCheckBoxStatus: state.getIn(["npaFormReducer", "tempCheckBoxStatus"]),
  activePageStepNumber: state.getIn(["globalState", "activePageStepNumber"])
});

const mapDispatchToProps = dispatch => ({
  editStepperIndex: data => dispatch(editStepperIndex(data)),
  updateStepperAllToFinish: data => dispatch(updateStepperAllToFinish(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InfoRectangleNPA)
);
